import React, { Component } from 'react'
import ResourceThumbnail from './ResourceThumbnail'
import ResourceDetailsPopUp from './ResourceDetailsPopUp'
import Filter from './Filter'

import { ResourceInfo, Resources } from '../../schema/types.d'

interface ResourcesListState {
  selectedResource: ResourceInfo.Fragment
  searchText: string
}

class ResourcesList extends Component<Resources.Props, ResourcesListState> {
  constructor(props: Resources.Props) {
    super(props)
    this.state = {
      selectedResource: null,
      searchText: null
    }
    this.changeSearch = this.changeSearch.bind(this)
  }

  changeSearch(searchText: string) {
    this.setState({
      searchText: searchText
    })
  }

  render() {
    return (
      <div>
        <Filter
          changeSearch={this.changeSearch}
          title="Employees"
          placeholder="Search.."
        />
        <Resources.Component variables={{ searchFor: this.state.searchText }}>
          {({ loading, error, data }) => {
            if (loading) return <div>Fetching</div>
            if (error) return <div>Error</div>
            const resources = data.resources
            const totalCount = resources.length
            return (
              <div>
                <h1 className="f6 bg-washed-blue gray mv0 pv1 ph3">
                  <span className="pr3">{totalCount} Employees</span>
                </h1>
                <div className="flex flex-wrap w-80 center">
                  {resources.map(resource => (
                    <ResourceThumbnail
                      key={resource.id}
                      resource={resource}
                      onDetailsClick={() =>
                        this.setState({ selectedResource: resource })
                      }
                    />
                  ))}
                </div>
                <div />
                {this.state.selectedResource && (
                  <ResourceDetailsPopUp
                    id={this.state.selectedResource.id}
                    onCloseClick={() =>
                      this.setState({ selectedResource: null })
                    }
                  />
                )}
              </div>
            )
          }}
        </Resources.Component>
      </div>
    )
  }
}

export default ResourcesList
